module.exports = __webpack_public_path__ + "static/media/icon_settings.17adf087.png";